/**
 * Sends the browser to the portal's `/logout`, which ends the portal session and comes back to
 * this app's `/logout/callback`. Its own module so tests can stand in for the navigation.
 */
export const goToPortalLogout = (): void => {
  document.location.href = `${import.meta.env['VITE_API_URL']}/logout?target_url=${encodeURIComponent(window.location.origin + '/logout/callback')}`;
};
